import { EmptyPractitionerWaitingListCallout, WaitingListContentHeader } from '~/app/pages/SurgeonScheduler/shared'
import { AstraSkeletonLoader } from '~/astra'
import { PractitionerWaitingListCallout } from '~/components'
import { useCurrentWaitingListByPractitioner } from '~/hooks/useCurrentWaitingListByPractitioner'
import { useStore } from '~/store/store'
import { Practitioner } from '~/storm'

import { WaitingListByPractitionerBarList } from './WaitingListByPractitionerBarList'

type Props = {
    practitioner: Practitioner
}

export const CurrentWaitingListPopoverContent = ({ practitioner }: Props) => {
    const {
        isLoading,
        isError,
        isWaitingListEmpty,
        unScheduledSurgeriesByPractitioner,
        unScheduledSurgeriesByPractitionerCount,
        isWaitingListByPractitionerEmpty,
        clearedSurgeriesByPractitionerCount,
    } = useCurrentWaitingListByPractitioner(practitioner)

    const hasDeniedAccessItems = useStore(state => state.waitingList.hasDeniedAccessItems)

    if (isLoading) {
        return (
            <div className="h-12 w-full">
                <AstraSkeletonLoader />
            </div>
        )
    }

    if (isError) return <PractitionerWaitingListCallout type="error" />

    if (isWaitingListEmpty && hasDeniedAccessItems) return <PractitionerWaitingListCallout type="noAccess" />

    return (
        <div className="flex h-full w-full flex-col gap-y-2 self-center overflow-hidden">
            <div className="rounded border bg-surface-base px-4 py-2">
                <WaitingListContentHeader
                    unScheduledSurgeriesByPractitionerCount={unScheduledSurgeriesByPractitionerCount}
                    clearedSurgeriesByPractitionerCount={clearedSurgeriesByPractitionerCount}
                />
            </div>

            {hasDeniedAccessItems && <PractitionerWaitingListCallout type="restrictedAccess" />}

            {isWaitingListByPractitionerEmpty ? (
                <EmptyPractitionerWaitingListCallout />
            ) : (
                <WaitingListByPractitionerBarList unScheduledSurgeriesByPractitioner={unScheduledSurgeriesByPractitioner} />
            )}
        </div>
    )
}
